import { render, staticRenderFns } from "./PortalNavMenu.vue?vue&type=template&id=4edd1fd4&"
import script from "./PortalNavMenu.vue?vue&type=script&lang=js&"
export * from "./PortalNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./PortalNavMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemActionText } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCard,VIcon,VList,VListItem,VListItemActionText,VMenu,VSubheader})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src512482050/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4edd1fd4')) {
      api.createRecord('4edd1fd4', component.options)
    } else {
      api.reload('4edd1fd4', component.options)
    }
    module.hot.accept("./PortalNavMenu.vue?vue&type=template&id=4edd1fd4&", function () {
      api.rerender('4edd1fd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PortalNavMenu.vue"
export default component.exports